import React, { useEffect, useState } from "react";
import moment from "moment";
import { DateRangePicker } from "react-date-range";
import "assets/css/react-range-picker.min.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const CustomDateRangePicker = ({
  dateRangeState,
  setDateRangeState,
  months = 3,
  onRangeSelected, // <-- NEW (optional)
  ...props
}) => {
  const [isMobile, setIsMobile] = useState(window?.innerWidth <= 640);
  const [isTablet, setIsTablet] = useState(window?.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
      setIsTablet(window.innerWidth <= 991);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDateChange = (item) => {
    const selection = item.selection;
    // update local controlled range
    setDateRangeState([selection]);

    // if user has selected both ends of the range, notify parent immediately
    if (selection?.startDate && selection?.endDate && typeof onRangeSelected === "function") {
      onRangeSelected({
        startDate: selection.startDate,
        endDate: selection.endDate,
      });
    }
  };

  return (
    <DateRangePicker
      {...props}
      direction="horizontal"
      calendarFocus="backwards"
      ranges={dateRangeState}
      onChange={handleDateChange}
      rangeColors={["#e3910a"]}
      // minDate={moment().subtract(90, "days").toDate()}
      maxDate={moment().toDate()}
      months={isMobile ? 1 : isTablet ? 2 : months}
      showSelectionPreview={false}
      preventSnapRefocus={true}
      moveRangeOnFirstSelection={false}
      showMonthAndYearPickers={false}
      showDateDisplay={false}
    />
  );
};

export default CustomDateRangePicker;
